class OrderNotPaidMailSender {
    constructor() {
        this.sendButton = '#send_not_paid_email_btn';
        this.messageBox = '#send_not_paid_email-message';
    }

    init() {
        $(document).on('click', this.sendButton, (event) => {
            event.stopPropagation();
            this.sendMail();
        });
    }

    sendMail() {
        let self = this;
        let order_id = $('#order_id').val();
        $.post('/shop/orders/send_not_paid_email', {order_id: order_id}).then((response) => {
            self.showResponse(response.message, response.success);
        });
    }

    setMessageClass(messageBox, isSuccess) {
        if (isSuccess) {
            messageBox.removeClass('error-message');
            messageBox.addClass('success-message');
        } else {
            messageBox.removeClass('success-message');
            messageBox.addClass('error-message');
        }
    }

    showResponse(message, isSuccess = true) {
        let messageBox = $(this.messageBox);
        this.setMessageClass(messageBox, isSuccess);
        messageBox.html(message);
        messageBox.show();
    }
}

export default OrderNotPaidMailSender;
